import request from './request';
import {
    encryptAES,
    decryptAES
} from "@/libs/encrypt-utils";

export function getPayments(hospId) {
    return request.get('/api/personalOrder/GetPayments', {
        params: {
            hospId
        }
    });
}

/**
 * 提前创建用户订单信息（不保存到数据库），并生成订单号和签名字段
 */
export function createOrder(userOrder) {
    //提交前脱敏处理
    userOrder.idcard = encryptAES(userOrder.idcard);
    userOrder.mobile = encryptAES(userOrder.mobile);
    return new Promise(function (resolve, reject) {
        request.post('/api/PersonalOrder/CreateUserOrder', userOrder).then(res => {
            if (res && res.code == 200 && res.data) {
                res.data.idcard = decryptAES(res.data.idcard);
                res.data.mobile = decryptAES(res.data.mobile);
            }
            resolve(res);
        })
    })
}

export function saveOrder(userOrder) {
    //提交前脱敏处理
    userOrder.idcard = encryptAES(userOrder.idcard);
    userOrder.mobile = encryptAES(userOrder.mobile);
    return new Promise(function (resolve, reject) {
        request.post('/api/PersonalOrder/SaveUserOrder', userOrder).then(res => {
            if (res && res.code == 200 && res.data) {
                res.data.idcard = decryptAES(res.data.idcard);
                res.data.mobile = decryptAES(res.data.mobile);
            }
            resolve(res);
        })
    })
}

export function getUserOrders(hospId, userId) {
    return new Promise(function (resolve, reject) {
        request
            .get('/api/personalOrder/GetUserOrders', {
                params: {
                    hospId,
                    userId
                }
            }).then(res => {
                if (res) {
                    res.forEach(it => {
                        it.idcard = decryptAES(it.idcard);
                        it.mobile = decryptAES(it.mobile);
                    })
                }
                resolve(res);
            })
    })

    /*
    return request.get('/api/personalOrder/GetUserOrders', {
        params: {
            hospId,
            userId
        }
    });*/
}

export function getUserOrder(hospId, orderNo) {
    return new Promise(function (resolve, reject) {
        request.get('/api/personalOrder/GetUserOrder', {
            params: {
                hospId,
                orderNo
            }
        }).then(res => {
            if (res && res.code == 200 && res.data) {
                res.data.idcard = decryptAES(res.data.idcard);
                res.data.mobile = decryptAES(res.data.mobile);
            }
            resolve(res);
        })
    })
    /*
    return request.get('/api/personalOrder/GetUserOrder', {
        params: {
            hospId,
            orderNo
        }
    });
        */
}

export function cancelOrder(orderId) {
    let postParam = {
        Value: orderId.toString()
    };
    return request.post('/api/PersonalOrder/CancelOrder', postParam);
}

export function confirmOrder(id) {
    return request.put(`/order/${id}/finish`)
}

export function payOrder(params) {
    return request.get('/paySuccess', {
        params
    })
}